import { inRange } from 'lodash';
import { createSelector } from 'reselect';

import { format } from '@r1-frontend/ui-react/components/costs';

import { selectCurrentTariff } from '~/src/features/full-buy/store/selectors/selectCurrentTariff';

interface IBannerInfo {
    title: string,
    subtitle: string,
    path: string,
    tariffName: string,
}

const MIN_SPEED_IN_RANGE = 100;
const MAX_SPEED_IN_RANGE = 301;

// Собирает баннер из recommendedPacket
export const selectBannerInfoForFullBuy = createSelector(
    selectCurrentTariff,
    (tariff): IBannerInfo | null => {
        const speedInRange = tariff && inRange(tariff.speed, MIN_SPEED_IN_RANGE, MAX_SPEED_IN_RANGE);

        if (!tariff || !tariff.isMono || !tariff.recommendedPackets?.length || !speedInRange) {
            return null;
        }

        const [recommendedPacket] = tariff.recommendedPackets;
        const { priceFinal, promoPriceFinal, promoDuration, sale_package_id } = recommendedPacket;

        return ({
            tariffName: recommendedPacket.title,
            title: `Успейте подключить Интернет+ТВ по&nbsp;цене Интернета на&nbsp;${promoDuration}&nbsp;месяца`,
            subtitle: `${format(promoPriceFinal, { monthly: true })} вместо ${format(priceFinal, { monthly: true })}`,
            path: `/full-buy?salePackageId=${sale_package_id}`,
        });
    },
);
